/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-04-06T15:38:00-07:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-19T16:42:49-07:00
 */


import React, { Component } from 'react';
import { dimensions, spacing, size, type, leading, borders } from '../../../style';
import Panel from '../../common/Panel';
import Avatar from '../../common/Avatar';
import { tsYears, tsDate, tsSince } from '../../../common';
import { MediaQuery } from 'react-responsive'
import glamorous from 'glamorous'

class UserProfileCard extends Component {
  render() {
    let { profile } = this.props;
    let pData = profile.profile.data;
    let avatar = pData.avatar.data.urls.thumbs;

    return (
      <Container>
        <Panel>
          <TopRow>
            <ProfileImg>
              <Avatar src={avatar} />
            </ProfileImg>
            <InfoContainer>
              <Title>{profile.username}</Title>
              <div className={''}>{pData.age} • {pData.city}, {pData.region}</div>
              <Membership>{profile.membership_expires ?
                  `Premium Member - until ${tsDate(profile.membership_expires.date)} (${tsSince(profile.membership_expires.date)})`
                : 'Standard Member'}</Membership>
            </InfoContainer>

          </TopRow>
        </Panel>
      </Container>
    );
  }
}

const ProfileImg = glamorous.div({
    height: 82,
    width: 82,

    [dimensions.SCREEN_MAX_MD]: {
      ...spacing.MARGIN_RIGHT_MD
    },

    [dimensions.SCREEN_MIN_MD]: {
      margin: '0 auto',
      marginTop: '-66px',
      height: 120,
      width: 120,
    }
})

const Container = glamorous.div({
  [dimensions.SCREEN_MIN_MD]: {
    paddingTop: 50
  },

  [dimensions.SCREEN_MAX_MD]: {
    ...spacing.PADDING_MD,
    ...spacing.MARGIN_BOTTOM_MD,
    backgroundColor: '#fff',
    borderBottom: borders.DEFAULT
  }
})

const InfoContainer = glamorous.div({
    [dimensions.SCREEN_MIN_MD]: {
      ...spacing.MARGIN_TOP_SM,
      textAlign: 'center'
    }
})

const Title = glamorous.div({
    ...type.LG,
})

const TopRow = glamorous.div({
    display: 'flex',
    [dimensions.SCREEN_MIN_MD]: {
      flexDirection: 'column',
    }
})

const Membership = glamorous.div({
    ...type.SM,
    ...spacing.PADDING_V_XS,
})

export default UserProfileCard;



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/UserProfileCard.jsx